import { render, staticRenderFns } from "./ComplianceStandards.vue?vue&type=template&id=04bcea80&scoped=true"
import script from "./ComplianceStandards.vue?vue&type=script&lang=js"
export * from "./ComplianceStandards.vue?vue&type=script&lang=js"
import style0 from "./ComplianceStandards.vue?vue&type=style&index=0&id=04bcea80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bcea80",
  null
  
)

export default component.exports